// extracted by mini-css-extract-plugin
module.exports = {"component":"UsersPage_component__3NJDA","content":"UsersPage_content__2hMLR","button":"UsersPage_button__HB0rG","header":"UsersPage_header__1EcCI"};